class SnackbarMessage {
  uploadDocuments = {
    success: 'Dokument(e) erfolgreich hochgeladen.',
    error: 'Fehler beim Hochladen von Dokument(en).'
  };
  downloadDocuments = {
    success: 'Dokument wurde erfolgreich heruntergeladen.',
    error: 'Fehler: Dokument wurde nicht heruntergeladen.'
  };
  removeDocuments = {
    success: 'Dokument erfolgreich entfernt.',
    error: 'Fehler: Das Dokument wurde nicht entfernt.'
  };
}

export const snackbarMessage = new SnackbarMessage();
